module.exports = __webpack_public_path__ + "static/media/search.7b957746.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/search.svg
// module id = 584
// module chunks = 0